import { render, staticRenderFns } from "./DropzoneFormNovo.vue?vue&type=template&id=d8971fd4&"
import script from "./DropzoneFormNovo.vue?vue&type=script&lang=js&"
export * from "./DropzoneFormNovo.vue?vue&type=script&lang=js&"
import style0 from "./Dropzone.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VContainer,VForm,VScrollYTransition})
